import { render, staticRenderFns } from "./BankFlowSuggestion.vue?vue&type=template&id=653444cc&"
import script from "./BankFlowSuggestion.vue?vue&type=script&lang=js&"
export * from "./BankFlowSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports